{
  "name": "lumen-dashboards",
  "version": "0.1.8",
  "private": true,
  "dependencies": {
    "@babel/polyfill": "^7.8.7",
    "@date-io/moment": "^1.3.13",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.0",
    "@fortawesome/fontawesome-svg-core": "^1.2.36",
    "@fortawesome/free-brands-svg-icons": "^5.15.4",
    "@fortawesome/free-solid-svg-icons": "^5.15.4",
    "@fortawesome/react-fontawesome": "^0.1.16",
    "@lumen-developer/lumen-feature-editor-component": "2.0.23",
    "@lumen-developer/lumen-lookalikes": "^0.3.7",
    "@mui/icons-material": "^5.17.1",
    "@mui/lab": "^5.0.0-alpha.119",
    "@mui/styles": "^6.4.11",
    "@mui/system": "^5.11.14",
    "@mui/x-date-pickers": "^6.20.2",
    "@parcel/packager-raw-url": "^2.15.2",
    "@parcel/transformer-postcss": "^2.15.2",
    "@parcel/transformer-sass": "^2.15.2",
    "@parcel/transformer-webmanifest": "^2.15.2",
    "@superset-ui/embedded-sdk": "^0.4.0",
    "@testing-library/user-event": "^13.1.5",
    "apexcharts": "4.0.0",
    "autoprefixer": "^10.4.21",
    "aws-sdk": "^2.1692.0",
    "axios": "^0.18.1",
    "babel-upgrade": "0.0.24",
    "d3": "5.7.0",
    "d3-array": "1.2.1",
    "d3-axis": "1.0.8",
    "d3-brush": "1.0.4",
    "d3-geo": "1.10.0",
    "d3-scale": "2.0.0",
    "d3-scale-chromatic": "1.3.0",
    "d3-selection": "1.3.0",
    "d3-shape": "1.2.0",
    "d3-svg-legend": "2.25.6",
    "d3-time-format": "2.1.1",
    "d3-transition": "1.1.1",
    "date-fns": "^2.30.0",
    "evaporate": "^2.1.4",
    "fetch-mock": "7.2.5",
    "formik": "^2.4.6",
    "formik-mui": "^4.0.0-alpha.3",
    "formik-mui-lab": "^1.0.0",
    "globalize": "^1.7.0",
    "moment": "^2.29.1",
    "moment-timezone": "^0.5.34",
    "node": "^24.9.0",
    "postcss": "^8.5.4",
    "query-string": "6.3.0",
    "react": "18.0.0",
    "react-apexcharts": "1.7.0",
    "react-beautiful-dnd": "13.1.1",
    "react-copy-to-clipboard": "^5.0.4",
    "react-csv": "^1.0.14",
    "react-datetime": "^3.1.1",
    "react-dom": "18.0.0",
    "react-draggable": "^4.4.4",
    "react-dropzone": "^14.3.5",
    "react-flag-kit": "^1.1.1",
    "react-iframe": "1.5.0",
    "react-router-breadcrumbs-hoc": "4.1.0",
    "react-simple-tree-menu": "^1.1.18",
    "react-spinners": "^0.13.8",
    "react-widgets-globalize": "^5.0.23",
    "recharts": "^2.1.8",
    "redux": "^5.0.1",
    "regenerator-runtime": "0.13.1",
    "rison": "^0.1.1",
    "rollbar": "^2.24.0",
    "sass": "1.89.0",
    "styled-components": "4.0.3",
    "validator": "^13.6.0",
    "yup": "0.27.0"
  },
  "scripts": {
    "clean-dist": "rm -rf dist && mkdir dist",
    "development": "parcel src/index.html -p 3000 --log-level verbose ",
    "development no cache": "parcel src/index.html --no-cache -p 3000 --log-level verbose ",
    "build": "parcel build src/index.html",
    "start": "parcel src/index.html -p 3000",
    "lint": "eslint src",
    "generate-build-version": "node generate-build-version",
    "prebuild": "npm run generate-build-version",
    "sass:watch": "sass -w src/styles/scss -o src/styles/css",
    "sass:build": "sass src/styles/scss:../src/styles/css",
    "test": "jest --maxWorkers 2 --silent=false",
    "test:windows": "node --expose-gc .\\node_modules\\jest\\bin\\jest.js --runInBand --logHeapUsage",
    "serve": "serverless offline start",
    "cypress:open": "cypress open"
  },
  "devDependencies": {
    "@babel/core": "^7.27.4",
    "@babel/preset-env": "^7.27.2",
    "@babel/preset-react": "^7.16.7",
    "@testing-library/jest-dom": "^6.6.3",
    "@testing-library/react": "^16.3.0",
    "@types/jest": "^30.0.0",
    "babel-jest": "^30.0.2",
    "babel-preset-react-app": "^10.1.0",
    "babel-preset-stage-0": "^6.24.1",
    "buffer": "^6.0.3",
    "classnames": "^2.3.1",
    "core-js": "3.24.0",
    "cypress": "^3.8.3",
    "dotenv": "^17.3.1",
    "enzyme": "^3.11.0",
    "eslint": "^8.57.1",
    "eslint-config-react-app": "^7.0.1",
    "eslint-plugin-prettier": "^4.0.0",
    "expect": "^23.6.0",
    "i": "^0.3.7",
    "identity-obj-proxy": "^3.0.0",
    "jest": "29.7.0",
    "jest-canvas-mock": "^2.3.1",
    "jest-cli": "^26.6.0",
    "jest-dom": "^3.2.2",
    "jest-environment-jsdom": "^30.0.2",
    "jest-localstorage-mock": "^2.4.18",
    "jest-watch-typeahead": "^2.2.2",
    "moxios": "^0.4.0",
    "normalize-scss": "^7.0.1",
    "npm": "^6.14.15",
    "parcel": "^2.15.2",
    "postcss-load-config": "^6.0.1",
    "prettier": "^2.5.1",
    "process": "^0.11.10",
    "react-error-overlay": "^6.0.9",
    "react-redux": "7.2.8",
    "react-router-dom": "5.3.2",
    "react-scripts": "5.0.0",
    "react-test-renderer": "18.0.0",
    "react-testing-library": "^7.0.0",
    "redux-logger": "^3.0.6",
    "redux-mock-store": "^1.5.4",
    "redux-thunk": "3.1.0",
    "remote-redux-devtools": "^0.5.13",
    "serverless": "^1.83.3",
    "serverless-offline": "^3.25.3",
    "serverless-webpack": "^5.6.0",
    "sinon": "^7.2.3"
  },
  "browserslist": [
    ">0.2%",
    "not dead",
    "not ie <= 11",
    "not op_mini all"
  ]
}